import * as React from "react";
import Svg, { Path, Rect, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Rect, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { 
      fill: true,
      stroke: true,
    },
  },
});

type RadioInputIconProps = SvgProps & {
  className?: string;
  rectFillClassName?: string;
  rectStrokeClassName?: string;
};

function RadioIcon({
  className,
  rectFillClassName = "fill-white",
  rectStrokeClassName = "stroke-gray-200",
  ...props
}: RadioInputIconProps) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    className={className}
    >
      <Rect x={3} y={3} width={14} height={14} rx={7} fill="#fff" className={rectFillClassName} />
      <Rect
        x={3}
        y={3}
        width={14}
        height={14}
        rx={7}
        stroke="#319795"
        strokeWidth={6}
        className={rectStrokeClassName}
      />
    </Svg>
  );
}

export default RadioIcon;
